import { fmt } from '../model/tiles.js'
import { Tile } from '../tiles/index.js'

const MAP = {
  dark: {
    box: 'inline-flex items-center gap-[5px] bg-white/5 border border-white/10 rounded-lg px-2 py-[5px] text-[10.5px]',
    wind: 'font-serif font-bold text-[#e2a93b]',
    name: '',
    score: 'opacity-55',
    dot: 'w-[7px] h-[7px] rounded-full bg-[#c0392b]',
    lastLabel: 'last',
    last: 'opacity-40',
  },
  industry: {
    box: 'inline-flex items-center gap-[6px] border border-neutral-300 bg-white rounded-none px-[9px] py-[5px] text-[10.5px]',
    wind: 'font-heading font-semibold text-accent-700',
    name: 'font-semibold',
    score: 'text-neutral-600',
    dot: 'w-[7px] h-[7px] bg-accent',
    lastLabel: 'LAST',
    last: 'text-neutral-500 tracking-[1px] text-[9px] uppercase',
  },
}

export default function OpponentChip({ wind, name, score, riichi, last = [], theme = 'dark' }) {
  const m = MAP[theme] || MAP.dark
  return (
    <div className={m.box}>
      <span className={m.wind}>{wind}</span>
      <span className={m.name}>{name}</span>
      <span className={m.score}>{fmt(score)}</span>
      {riichi && <span className={m.dot} />}
      <span className={m.last}>{m.lastLabel}</span>
      {last.length > 0 && <Tile tile={last[0]} width={13} />}
    </div>
  )
}
